module.exports = __webpack_public_path__ + "static/media/IMG_0004.b654e1a2.jpg";